import { Link } from "react-router-dom";

export const AccessibilityPage = () => {
  const lastUpdated = "April 2026";

  return (
    <div id="main-content" className="pt-20" data-testid="accessibility-page">
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="overline text-brand-primary mb-4">Legal</p>
          <h1 className="font-serif text-4xl sm:text-5xl font-light text-slate-900 leading-tight mb-4">
            Accessibility Statement
          </h1>
          <p className="text-sm text-slate-500 mb-10">Last updated: {lastUpdated}</p>

          <div className="prose-custom space-y-6 text-slate-700 leading-relaxed">
            <p>
              The Centre for Consciousness Studies Australia is committed to ensuring that its website is
              accessible to the widest possible audience, including people with disabilities.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Our Commitment</h2>
            <p>
              We aim to conform with the Web Content Accessibility Guidelines (WCAG) 2.1 at Level AA.
              These guidelines explain how to make web content more accessible to people with a wide
              range of disabilities, including visual, auditory, cognitive, and motor impairments.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Measures We Have Taken</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Semantic HTML structure with meaningful headings and landmarks;</li>
              <li>Keyboard navigation support throughout the site;</li>
              <li>A "Skip to main content" link at the top of every page;</li>
              <li>Descriptive alt text for informative images;</li>
              <li>Sufficient colour contrast between text and background;</li>
              <li>Readable typography with scalable font sizes;</li>
              <li>Responsive layouts across desktop, tablet, and mobile devices;</li>
              <li>Focus states on interactive elements for keyboard and screen-reader users.</li>
            </ul>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Known Limitations</h2>
            <p>
              Some content embedded from third-party platforms (such as video players and academic
              publisher links) is outside our direct control and may not fully meet our accessibility
              standards. Where you encounter such content and need an accessible alternative, please
              contact us and we will assist.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Feedback</h2>
            <p>
              We welcome feedback on the accessibility of this site. If you experience barriers or have
              suggestions for improvement, please{" "}
              <Link to="/contact" className="text-brand-primary hover:underline">
                contact the Centre
              </Link>
              . We aim to acknowledge feedback within five business days.
            </p>

            <h2 className="font-serif text-2xl text-slate-900 mt-10 mb-4">Ongoing Review</h2>
            <p>
              Accessibility is an ongoing effort. We review and update this site regularly as standards
              evolve and as we receive feedback from our community.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AccessibilityPage;
